import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'ramda';
import { withFormik } from 'formik';
import moment from 'moment';

import { handleError, handleSuccess } from '../../util/forms';
import { apiUpdateRegistration } from '../../api/registration';

import Modal from '../Modal';
import EditField from '../Forms/EditField';

class EditRegistrationModal extends Component {
  static propTypes = {
    registration: PropTypes.object,
    onHide: PropTypes.func,
    updateRegistration: PropTypes.func,
  };

  state = {
    show: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const { onHide, values, handleBlur, handleChange, handleSubmit, isSubmitting, isValid, status } = this.props;
    const { show } = this.state;

    return (
      <Modal show={show} onHide={onHide} title="Edit Registration">
        <form>
          <Modal.Body className="px-5">
            <EditField
              block
              type="number"
              name="requiredHours"
              label="Required Experience Hours"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.requiredHours}
            />
            <EditField
              block
              type="date"
              name="deadline"
              label="Deadline"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.deadline}
            />
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, payload)
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(props.onHide)
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration = {} }) => {
    return {
      id: registration.id,
      requiredHours: defaultTo('', registration.requiredHours),
      deadline: registration.deadline ? moment(registration.deadline).format('YYYY-MM-DD') : '',
    };
  },
  isInitialValid: true,
  validateOnChange: true,
})(EditRegistrationModal);
